// extracted by mini-css-extract-plugin
export default {"main_container":"PaymentStatus_main_container__i8+Yr","title":"PaymentStatus_title__rPIG4","description":"PaymentStatus_description__vMA-d","btn":"PaymentStatus_btn__Y6UHo"};